import { Section } from 'components/common/override-rates/Section';
import ProductLineTitleV2 from 'components/common/general/ProductLineTitleV2';
import styled from 'styled-components';

export const SectionStyled = styled(Section)`
  margin-bottom: 5rem;
`;

export const ProductLineTitleV2Styled = styled(ProductLineTitleV2)`
  padding: 3rem 0;
`;
